/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardLimitResponseViewModel } from "../types/CreditCardLimitResponseViewModel.ts";
import { creditCardLimitCreditDatesResponseViewModelSchema } from "./creditCardLimitCreditDatesResponseViewModelSchema.ts";
import { creditCardLimitFeeResponseViewModelSchema } from "./creditCardLimitFeeResponseViewModelSchema.ts";
import { creditCardLimitRefundResponseViewModelSchema } from "./creditCardLimitRefundResponseViewModelSchema.ts";

export const creditCardLimitResponseViewModelSchema = z.object({
  id: z.string().nullish(),
  invoiceId: z.string().nullish(),
  receiptId: z.string().nullish(),
  paymentGatewayChargeId: z.string().nullish(),
  paymentGatewayTid: z.string().nullish(),
  amountPaid: z.optional(z.number()),
  amount: z.optional(z.number()),
  paidAt: z.string().datetime().nullish(),
  error: z.string().nullish(),
  cardId: z.string().nullish(),
  firstSixDigits: z.string().nullish(),
  lastFourDigits: z.string().nullish(),
  brand: z.string().nullish(),
  chargedBackAt: z.string().datetime().nullish(),
  expirationMonth: z.string().nullish(),
  expirationYear: z.string().nullish(),
  status: z.string().nullish(),
  recurrenceCycle: z.string().nullish(),
  amountAvailable: z.number().nullish(),
  installments: z.number().int().nullish(),
  creditDates: z
    .array(z.lazy(() => creditCardLimitCreditDatesResponseViewModelSchema))
    .nullish(),
  refunds: z
    .array(z.lazy(() => creditCardLimitRefundResponseViewModelSchema))
    .nullish(),
  fees: z
    .array(z.lazy(() => creditCardLimitFeeResponseViewModelSchema))
    .nullish(),
}) as unknown as ToZod<CreditCardLimitResponseViewModel>;
